/**
**  项目管理---项目详情-项目历史界面
 */
<template>
  <div id="ProjectReport" class="jc-page">
    <div class="jc-panel jc-page-head">
	    <span class="header-title">
            <el-page-header @back="goBack" content="生成报告"></el-page-header>
        </span>
        <div class="header-operation">
            <el-button @click="downloadDocx">下载汇总清单</el-button>
	    <el-button @click="ok">确定</el-button>
        </div>
	</div>
    <div class="jc-table-container jc-scroll-panel">
        <template v-if="all_checkup_subject_item_list.length == 0">
        </template>
        <template v-else>
            <div class="subject-list">
                <div>请选择报告中表头展示信息</div>
                <div class="subject-item" v-for="subject in all_checkup_subject_item_list" :key="subject.checkup_subject_id">
                    <div>{{subject.checkup_subject_name}}</div>
                    <el-table :id="'table' + subject.checkup_subject_id"
                        :data="subject.rowData"
                        :default-sort="{prop: 'checkup_item_no', order: 'ascending'}"
                        :span-method="rowSpanMethod"
                        style="width: 100%;margin-bottom:20px;">
                        <el-table-column :render-header="renderHeader"
                            width="100"
                            v-for="property in properties" :key="property.propertyName"
                            :prop="property.propertyName"
                            :label="property.columnName">
                            <template slot-scope="scope">
                                <div v-html="renderColumn(property.propertyName, scope.row)"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
    </div>
  </div>
</template>
<script>
import {getAllCheckupSubjectItemListByPrjectId} from '@/apis/projects'
import axios from 'axios'
var reportDocLink=''
export default {
  name: "ProjectReport",
  data() {
    return {
      checkup_project_id:'',
      all_checkup_subject_item_list:[],
      properties:[
          { propertyName: "checkup_item_no", columnName: "检查编号"},
          { propertyName: "checkup_category_name", columnName: "类别"},
          { propertyName: "checkup_item_name", columnName: "项目"},
          { propertyName: "checkup_item_evaluation_content", columnName: "评估内容"},
          { propertyName: "checkup_item_basic_score", columnName: "标准分"},
          { propertyName: "checkup_item_score_point", columnName: "评分标准"},
          { propertyName: "checkup_item_standard_require", columnName: "标准化要求"},
          { propertyName: "checkup_item_standard_point", columnName: "企业达标标准"},
          { propertyName: "checkup_item_review_method", columnName: "评审方法"},
          { propertyName: "checkup_item_review_criteria_no_but", columnName: "评审标准-否决项"},
          { propertyName: "checkup_item_review_criteria_deduction", columnName: "评审标准-扣分项"},
          { propertyName: "checkup_item_standard_review_number", columnName: "标准化评审规范号"},
          { propertyName: "checkup_item_standard_review_content", columnName: "标准化评审内容"},
          { propertyName: "checkup_item_inspection_content", columnName: "检查内容/考核要求"},
          { propertyName: "checkup_item_inspection_basis", columnName: "检查依据"},
          { propertyName: "checkup_item_inspection_method", columnName: "检查方法"},
          { propertyName: "checkup_item_case_image", columnName: "案例照片"},
          { propertyName: "checkup_item_complete_time_limit", columnName: "完成时限"},
          { propertyName: "checkup_item_evaluation_key_issues", columnName: "是否重点问题"},
          { propertyName: "checkup_item_evaluation_method", columnName: "评估方式"},
          { propertyName: "checkup_item_inspection_point", columnName: "检查要点/支撑材料"},
          { propertyName: "checkup_item_evaluation_problem_description", columnName: "自评/评审描述"},
          { propertyName: "checkup_item_evaluation_improve_time_limit", columnName: "整改时限"},
          { propertyName: "checkup_item_evaluation_project_type_switch", columnName: "问题分类"},
          { propertyName: "checkup_item_evaluation_inspection_result", columnName: "检查结果"},
          { propertyName: "checkup_evaluation_problem_description", columnName: "问题描述"},
          { propertyName: "checkup_evaluation_improve_suggest", columnName: "整改建议"},
          { propertyName: "checkup_item_real_score", columnName: "实际得分"},
          { propertyName: "checkup_item_images",columnName: "照片"}
      ]
    };
  },
  mounted(){
    this.checkup_project_id = this.$route.params.id
    getAllCheckupSubjectItemListByPrjectId({
        checkup_project_id:this.checkup_project_id
    }).then(res=>{
        if(res.data.status == "1"){
            this.all_checkup_subject_item_list = [...res.data.data.all_checkup_subject_item_list]
            this.structData(),
	    fetch('http://39.100.112.87:8080/exportReport-1.0/rest/exportDocxUtil/exportDocx',{
            	method:'POST',
	    	headers:{
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body:`reportDataInJSON=${JSON.stringify(res.data.data)}`,
            	}).then((response) => response.text())
		.then((text) => {
			reportDocLink = text;
		});
        }
    })
  },

  methods:{
	structData(){
		let subjects = []
		for(let i=0; i< this.all_checkup_subject_item_list.length; i++){
			let subject = {
				"checkup_subject_id": this.all_checkup_subject_item_list[i].checkup_subject_id,
				"checkup_subject_name": this.all_checkup_subject_item_list[i].checkup_subject_name,
			}
			let checkup_item_list = this.all_checkup_subject_item_list[i].checkup_item_list
			let rowdatas = []
			for(let j=0; j<checkup_item_list.length; j++){
				let beforeData = {
					checkup_item_no:checkup_item_list[j].checkup_item_no,
                                        checkup_category_name:checkup_item_list[j].checkup_category_name,
					checkup_item_name:checkup_item_list[j].checkup_item_name,
					checkup_item_evaluation_content:checkup_item_list[j].checkup_item_evaluation_content,
					checkup_item_basic_score:checkup_item_list[j].checkup_item_basic_score,
					checkup_item_score_point:checkup_item_list[j].checkup_item_score_point,
					checkup_item_evaluation_method:checkup_item_list[j].checkup_item_evaluation_method,
					checkup_item_inspection_point:checkup_item_list[j].checkup_item_inspection_point,
					checkup_item_standard_require:checkup_item_list[j].checkup_item_standard_require,
					checkup_item_standard_point:checkup_item_list[j].checkup_item_standard_point,
					checkup_item_review_method:checkup_item_list[j].checkup_item_review_method,
					checkup_item_review_criteria_no_but:checkup_item_list[j].checkup_item_review_criteria_no_but,
					checkup_item_review_criteria_deduction:checkup_item_list[j].checkup_item_review_criteria_deduction,
					"checkup_item_evaluation_key_issues":checkup_item_list[j].checkup_item_evaluation_key_issues,
					checkup_item_standard_review_number:checkup_item_list[j].checkup_item_standard_review_number,
					checkup_item_standard_review_content:checkup_item_list[j].checkup_item_standard_review_content,
					checkup_item_inspection_content:checkup_item_list[j].checkup_item_inspection_content,
					checkup_item_inspection_basis:checkup_item_list[j].checkup_item_inspection_basis,
					checkup_item_inspection_method:checkup_item_list[j].checkup_item_inspection_method,
					checkup_item_case_image:checkup_item_list[j].checkup_item_case_image,
					checkup_item_complete_time_limit:checkup_item_list[j].checkup_item_complete_time_limit,
                                        checkup_item_real_score:checkup_item_list[j].checkup_item_real_score,
				}
				let checkup_item_inspection_point_content_list = 
					checkup_item_list[j].checkup_item_inspection_point_content_list
				let rowdata = []
				let rowspan1 = 0
				checkup_item_inspection_point_content_list.forEach(x=>{
					rowspan1 += x.expert_evaluation_list.length == 0 ? 1:x.expert_evaluation_list.length
				})
				if(rowspan1 == 0){
					rowspan1 = 1
				}
				let flag1 = false
				let flag2 = false
				checkup_item_inspection_point_content_list.forEach(x=>{
					if(x.expert_evaluation_list.length == 0){
						let row = {
							...beforeData,
							checkup_subject_item_evaluation_origin_id:x.checkup_subject_item_evaluation_origin_id,
							checkup_item_inspection_point:x.checkup_item_inspection_point,
							evaluation_method_type_info:x.evaluation_method_type_info,
							rowspan1:flag1 ? 0:rowspan1,
							rowspan2:1
						}
						flag1 = true
						rowdatas.push(row)
					} else {
						let flag2 = false
						x.expert_evaluation_list.forEach(y=>{
							let row = {
								...beforeData,
								checkup_subject_item_evaluation_origin_id:x.checkup_subject_item_evaluation_origin_id,
								checkup_item_inspection_point:x.checkup_item_inspection_point,
								evaluation_method_type_info:x.evaluation_method_type_info,
								...y,
								rowspan1:flag1 ? 0:rowspan1,
								rowspan2:flag2 ? 0:(x.expert_evaluation_list.length == 0 ? 1:x.expert_evaluation_list.length)
							}
							flag1 = true
							flag2 = true
							rowdatas.push(row)
						})
					}
					
				})
			}
			subject.rowData = rowdatas
			subjects.push(subject)
		}
		this.all_checkup_subject_item_list = subjects
	},
    goBack(){
      this.$router.back()
    },
    downloadDocx(){
      var a = document.createElement('a');
      var event = new MouseEvent('click');
      a.href = reportDocLink;
      console.log(reportDocLink);
      a.target="_blank";
      a.download=true;
      a.dispatchEvent(event);  
    },
    ok(){
	  let flag = false
      let selects = []
      this.all_checkup_subject_item_list.forEach(x=>{
            let select = {
                "checkup_subject_id": x.checkup_subject_id,
	            "checkup_subject_name": x.checkup_subject_name
            }
            let id = `table${x.checkup_subject_id}`
            let columns = document.querySelectorAll(`#${id} thead input[type="checkbox"]`)
            let selectColumn = []
            columns.forEach(y=>{
                if(y.checked){
                    selectColumn.push(y.getAttribute("column"))
                }
            })
			if(selectColumn.length > 0){
				flag = true
			}
            select.selectColumn = selectColumn
            selects.push(select)
      })
	  if(flag){
		this.$store.commit('user/setSelectColumns', selects)
      	this.$router.push('/Report/' + this.checkup_project_id)
	  } else {
		  this.$message.error("请选择要导出的表头信息")
	  }
      
    },
    renderHeader(h, {column, $index}){
        return h(
            "div",
            {
                domProps:{
                    innerHTML:`<input type="checkbox" column="${this.properties[$index].propertyName}">`+column.label
                }
            }
        )
    },
    rowSpanMethod({ row, column, rowIndex, columnIndex }){
        let rowspan1Column = [
            "checkup_item_no", "checkup_category_name", "checkup_item_name", "checkup_item_evaluation_content", "checkup_item_basic_score", 
            "checkup_item_score_point", "checkup_item_standard_require", "checkup_item_standard_point", "checkup_item_review_method", 
            "checkup_item_review_criteria_no_but", "checkup_item_review_criteria_deduction", "checkup_item_standard_review_number", "checkup_item_standard_review_content", 
            "checkup_item_inspection_content", "checkup_item_inspection_basis", "checkup_item_inspection_method", "checkup_item_case_image", 
            "checkup_item_complete_time_limit", "checkup_item_evaluation_key_issues","checkup_item_real_score"
        ]
        let rowspan2Column = ["checkup_item_inspection_point", "checkup_item_evaluation_method"]
        let propertyName = this.properties[columnIndex].propertyName
        if(rowspan1Column.indexOf(propertyName) > -1){
            return {rowspan:row.rowspan1, colspan:1}
        }
        if(rowspan2Column.indexOf(propertyName) > -1){
            return {rowspan:row.rowspan2, colspan:1}
        }
        return {rowspan:1, colspan:1}
    },
    renderColumn(property, row){
        switch(property){
            case "checkup_item_no": {
                return row.checkup_item_no
            }
            case "checkup_category_name": {
                return row.checkup_category_name
            }
            case "checkup_item_name": {
                return row.checkup_item_name
            }
            case "checkup_item_evaluation_content": {
                return row.checkup_item_evaluation_content
            }
            case "checkup_item_basic_score": {
                return row.checkup_item_basic_score
            }
            case "checkup_item_score_point": {
                return row.checkup_item_score_point
            }
            case "checkup_item_standard_require": {
                return row.checkup_item_standard_require
            }

            case "checkup_item_standard_point": {
                return row.checkup_item_standard_point
            }
            case "checkup_item_review_method": {
                return row.checkup_item_review_method
            }
            case "checkup_item_review_criteria_no_but": {
                return row.checkup_item_review_criteria_no_but
            }
            case "checkup_item_review_criteria_deduction": {
                return row.checkup_item_review_criteria_deduction
            }
            case "checkup_item_standard_review_number": {
                return row.checkup_item_standard_review_number
            }
            case "checkup_item_standard_review_content": {
                return row.checkup_item_standard_review_content
            }

            case "checkup_item_inspection_content": {
                return row.checkup_item_inspection_content
            }
            case "checkup_item_inspection_basis": {
                return row.checkup_item_inspection_basis
            }
            case "checkup_item_inspection_method": {
                return row.checkup_item_inspection_method
            }
            case "checkup_item_case_image": {
                return row.checkup_item_case_image
            }
            case "checkup_item_complete_time_limit": {
                return row.checkup_item_complete_time_limit
            }
            case "checkup_item_evaluation_key_issues": {
                return row.checkup_item_evaluation_key_issues == "0" ? "否":"是"
            }
            case "checkup_item_evaluation_method": {
                return row.evaluation_method_type_info.evaluation_method_type_name
            }
            case "checkup_item_inspection_point": {
                return row.checkup_item_inspection_point
            }
            case "checkup_item_evaluation_problem_description": {
                return row.checkup_item_evaluation_problem_description
            }
            case "checkup_item_evaluation_improve_time_limit": {
                return row.checkup_item_evaluation_improve_time_limit
            }
            case "checkup_item_evaluation_project_type_switch": {
                return row.checkup_item_evaluation_project_type_switch
            }
            case "checkup_item_evaluation_inspection_result": {
                return row.checkup_item_evaluation_inspection_result
            }
            case "checkup_evaluation_problem_description": {
                return row.checkup_evaluation_problem_description
            }
            case "checkup_evaluation_improve_suggest": {
                return row.checkup_evaluation_improve_suggest
            }
            case "checkup_item_real_score": {
                return row.checkup_item_real_score
            }
        }
    }
  }
};
</script>
<style scoped>
#ProjectReport {
  position: relative;
}

.subject-list{
    text-align:left;
}

.subject-list > div:first-child{
    color:#101010;
    font-size:14px;
    height:30px;
}

.subject-item > div:first-child{
    color:#101010;
    font-size:16px;
    height:30px;
    font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Orgin/ProjectManag/Report/ProjectReport.vue